import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction } from "react";
import {
    AdicionarAlcadaDescontoController,
    AtualizarAlcadaDescontoController,
} from "../../../Controllers/Cobranca/AlcadaDesconto/AlcadaDescontoController";
import {
    ConsultarEmpresaController,
    ConsultarObraController,
} from "../../../Controllers/Cobranca/Obras/ObrasController";
import { ListarGruposController } from "../../../Controllers/Geral/Grupos/GruposController";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { IAlcadaDescontoPorGrupo } from "../../../Interfaces/Cobranca/AlcadaDesconto/AlcadaDescontoInterface";
import UnForm from "../../Form";

interface ICadastrarDescontoAlcadaProps {
    updateList: () => void;
    setShow: Dispatch<SetStateAction<boolean>>;
    alcadasDesconto?: IAlcadaDescontoPorGrupo;
}

export default function CadastrarDescontoAlcada(
    props: ICadastrarDescontoAlcadaProps
) {
    const {
        execute: adicionarAlcadaDesconto,
        loading: adicionarAlcadaDescontoLoading,
    } = useAsyncCallback(AdicionarAlcadaDescontoController);

    const {
        execute: atualizarAlcadaDesconto,
        loading: atualizarAlcadaDescontoLoading,
    } = useAsyncCallback(AtualizarAlcadaDescontoController);

    function handleCadastrarAlcada(formData: IAlcadaDescontoPorGrupo) {
        if (props.alcadasDesconto) {
            atualizarAlcadaDesconto({
                ...formData,
                ID_ALCADA_DESCONTO: props.alcadasDesconto.ID_ALCADA_DESCONTO,
            }).then(() => {
                props.updateList();
                props.setShow(false);
            });
        } else {
            adicionarAlcadaDesconto(formData).then(() => {
                props.updateList();
                props.setShow(false);
            });
        }
    }

    return (
        <div>
            <UnForm handleSubmit={handleCadastrarAlcada} className="mb-4">
                <div className="col-12 mb-4">
                    <UnForm.LazySelect
                        label="Empresa"
                        controller={ConsultarEmpresaController}
                        getDS={(e) => e.DS_EMPRESA}
                        getKeyValue={(e) => e.ID_EMPRESA}
                        defaultValue={props.alcadasDesconto?.ID_EMPRESA}
                        name="ID_EMPRESA"
                    >
                        <option />
                    </UnForm.LazySelect>
                </div>

                <div className="col-12 mb-4">
                    <UnForm.LazySelect
                        defaultValue={props.alcadasDesconto?.ID_OBRA}
                        label="Obra"
                        fatherName="ID_EMPRESA"
                        controller={ConsultarObraController}
                        getDS={(o) => o.DS_OBRA}
                        getKeyValue={(o) => o.ID_OBRA}
                        name="ID_OBRA"
                    >
                        <option />
                    </UnForm.LazySelect>
                </div>

                <div className="col-12 d-flex">
                    <div className="col-6" style={{ paddingLeft: 0 }}>
                        <UnForm.Input
                            defaultValue={
                                props.alcadasDesconto?.NUM_PERCENTUAL_MULTA
                            }
                            label="Percentual de Multa"
                            type="number"
                            name="NUM_PERCENTUAL_MULTA"
                            wrapperClassName="col-12"
                        />
                    </div>

                    <div className="col-6" style={{ paddingRight: 0 }}>
                        <UnForm.Input
                            defaultValue={
                                props.alcadasDesconto?.NUM_PERCENTUAL_JUROS
                            }
                            label="Percentual de Juros"
                            type="number"
                            name="NUM_PERCENTUAL_JUROS"
                            wrapperClassName="col-12"
                        />
                    </div>
                </div>

                <div className="col-12 d-flex">
                    <div className="col-6" style={{ paddingLeft: 0 }}>
                        <UnForm.Input
                            defaultValue={
                                props.alcadasDesconto?.NUM_MINIMO_PARCELAS
                            }
                            label="Número Parcelas Minímo"
                            type="number"
                            name="NUM_MINIMO_PARCELAS"
                            wrapperClassName="col-12"
                        />
                    </div>

                    <div className="col-6" style={{ paddingRight: 0 }}>
                        <UnForm.LazySelect
                            defaultValue={props.alcadasDesconto?.ID_GRUPO}
                            label="Grupo"
                            controller={ListarGruposController}
                            getDS={(g) => g.DS_GRUPO}
                            getKeyValue={(g) => g.ID_GRUPO}
                            name="ID_GRUPO"
                        >
                            <option />
                        </UnForm.LazySelect>
                    </div>
                </div>

                <div className="col-12 d-flex">
                    <div className="col-6" style={{ paddingLeft: 0 }}>
                        <UnForm.Input
                            defaultValue={
                                props.alcadasDesconto?.NR_INICIO_AGING
                            }
                            label="Início Inadimplência"
                            type="number"
                            name="NR_INICIO_AGING"
                            wrapperClassName="col-12"
                        />
                    </div>

                    <div className="col-6" style={{ paddingRight: 0 }}>
                        <UnForm.Input
                            defaultValue={props.alcadasDesconto?.NR_FIM_AGING}
                            label="Final Inadimplência"
                            type="number"
                            name="NR_FIM_AGING"
                            wrapperClassName="col-12"
                        />
                    </div>
                </div>

                <UnForm.SubmitButton
                    color="primary"
                    type="submit"
                    wrapperClassName="col-12"
                    className="py-4 w-100"
                    icon={faPlus}
                    loadingSize="sm"
                    loading={
                        adicionarAlcadaDescontoLoading ||
                        atualizarAlcadaDescontoLoading
                    }
                    outline
                >
                    {props.alcadasDesconto
                        ? "Editar Desconto Alçada"
                        : "Cadastrar Desconto Alçada"}
                </UnForm.SubmitButton>
            </UnForm>
        </div>
    );
}
